import { render, staticRenderFns } from "./k-flow-modify-information.vue?vue&type=template&id=746e69d4&scoped=true"
import script from "./k-flow-modify-information.vue?vue&type=script&lang=js"
export * from "./k-flow-modify-information.vue?vue&type=script&lang=js"
import style0 from "./k-flow-modify-information.vue?vue&type=style&index=0&id=746e69d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746e69d4",
  null
  
)

export default component.exports